import {Modal, Button, ButtonGroup, Table, Collapse, Fade} from 'react-bootstrap'
import {request} from '../../helpers/request'
import React from 'react'
import accounting from 'accounting'
import Icon from 'react-fa'
import {t} from '../../helpers/translate'
import _ from 'lodash'
import PaymentHistoryComponent from './PaymentHistoryComponent'
let config = require('config');

const BEFORE_REQUEST_CANCELLATION = 1;
const UNDER_CANCELLATION_PREVIEW = 2;
const CANCELLATION_CONFIRMED = 3;

class CancelPolicyConfirmationComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      cancellationStatus: BEFORE_REQUEST_CANCELLATION,
      cancellationError: null,
      cancellationMessage: null,
      data: null,
      refunds: [],
      statusCode: null,
      transactionFees: [],
      cancellationFees: [],
      checked: false,
      action: props.isRefund ?
              {
                actionUC: 'Refund',
                actionLC: 'refund',
                actionDone: 'Refunded'
              } :
              {
                actionUC: 'Cancel',
                actionLC: 'cancel',
                actionDone: 'Cancelled'
              }
    }
  }

  componentDidMount() {
    this.getCancellationFeesForPayments();
  }

  close() {
    this.setState({
      cancellationStatus: BEFORE_REQUEST_CANCELLATION,
      cancellationError: null,
      cancellationMessage: null,
      data: null,
      refunds: [],
      statusCode: null,
      transactionFees: [],
      cancellationFees: []
    }, this.props.onClose())
  }

  getInitialPayment(payments) {

    // There is only 1 payment for Policy 
    if (Object.entries(payments).length === 1) {
      return payments[0];
    }

    for (let [key, payment] of Object.entries(payments)) {
      if (payment.additional_data.initial_payment == true) {
        return payment;
      }
    }

    // Lump Payment: There is no payment with payment.additional_data.initial_payment == true
    // Return the 0th payment
    return payments[0];
  }

  getCancellationFeesForPayments() {

    let payments = this.props.data.payments;

    var policyCancellationFee;

    if (this.props.setCancellationFee) {
      // for Rimi: no other clients
      policyCancellationFee = this.state.checked ? 0 : this.props.policyCancellationFee;
    } else {
      // For NON-Rimi: they do not get to set the Cancellation fee
      policyCancellationFee = 0;
    }

    let cancellationFeesForPayments = [];
    let policyCancellationFeeLeftToBeUsed = policyCancellationFee;
    let feePortion = 0;

    for (let [key, payment] of Object.entries(payments)) {
      if (
        policyCancellationFeeLeftToBeUsed == 0
        || payment.total <= 0
        || payment.additional_data.status != 'succeeded'
        || payment.additional_data.payment_type == 'Policy Issue Fee'
        || payment.additional_data.hide_dashboard
        ) {
        cancellationFeesForPayments[key] = 0;
      } else {
          feePortion = Math.min(payment.total, policyCancellationFeeLeftToBeUsed)
          cancellationFeesForPayments[key] = feePortion;
          policyCancellationFeeLeftToBeUsed -= feePortion;
      }
    }
    this.setState({cancellationFees: cancellationFeesForPayments});

    return cancellationFeesForPayments;
  }

  getRefundConfiguration() {
    let refunds = this.props.data.payments.map((payment, index) => ({
        'payment_id': payment['id'],
        'transaction_fee': this.state.transactionFees[index] || 0,
        'cancellation_fee': this.state.cancellationFees[index],
    }));

    if (this.props.setCancellationFee) {
      let initialPayment = this.getInitialPayment(this.props.data.payments);
      let policyCancellationFee = initialPayment.additional_data.policy_cancellation_fee ? initialPayment.additional_data.policy_cancellation_fee : 0;

      if (policyCancellationFee > 0 && !this.state.checked) {
        return {
          'refunds': refunds,
          'policyCancellationFee': policyCancellationFee
        };
      }
    }

    return {
      'refunds': refunds
    };
  }

  requestCancellation () {
    this.setState({
      cancellationStatus: UNDER_CANCELLATION_PREVIEW,
      cancellationError: null
    });
    request(`${config.default.api}/policy/${this.props.source}/${this.props.applicationId}`,
            'DELETE',
            this.getRefundConfiguration(),
            this.handleCancellationPreviewResponse.bind(this),
            {
              'Content-Type': 'application/json'
            }
    );
  }

  confirmCancellation () {
    this.props.onClose('cancel');
    this.props.showLoading(`${this.state.action.actionUC}ing Policy`);
    this.setState({
      cancellationStatus: CANCELLATION_CONFIRMED
    });
    request(`${config.default.api}/cancellation/${this.state.data.id}`,
            'DELETE',
            {'application_id': this.state.data.application_id},
            this.handleConfirmCancellationResponse.bind(this),
            {
              'Content-Type': 'application/json'
            }
    );
  }

  changeTransactionFee(index, event) {
    if (!event.target.value) {
      return;
    }
    this.state.transactionFees[index] = parseFloat(event.target.value);
  }

  changeCancellationFee(index, event) {
    if (!event.target.value) {
      return;
    }
  }

  handleConfirmCancellationResponse(data, statusCode) {
    if (200 === statusCode) {
      this.props.showModal( t('Success'), t(`Your policy has been ${this.state.action.actionDone}`));
    } else {
      this.props.showModal( t('Error'), t(`Your policy was not ${this.state.action.actionDone}`));
    }
    this.props.hideLoading();
  }

  handleCancellationPreviewResponse(data, statusCode) {
    if (200 !== statusCode) {
      this.setState({
        cancellationStatus: BEFORE_REQUEST_CANCELLATION,
        cancellationError: data.messages[0]
      })
      return;
    }
    for (let i = 0; i < data.payments.length; i++) {
      this.state.refunds[i] = data.payments[i];
    }
    this.setState({
      data: data,
      cancellationMessage: data.message,
      refunds: this.state.refunds,
      statusCode: statusCode,
      cancellationError: null
    })
  }

  getCancellingView() {
    return <div className="div-center">
      <br />
      <Icon name="circle-o-notch" size="5x" spin/>
      <h3>{t('Cancelling policy...')}</h3>
    </div>
  }

  getAfterCancellingView() {
    if (this.state.statusCode === 200) {
      if (_.isEmpty(this.state.data.errors)) {
        return <div className="div-center">
          <br />
          <Icon name="check" size="5x"/>
          <h3>{t('Policy cancelled')}</h3>
        </div>
      } else {
        return <div className="div-center">
          <br />
          <Icon name="warning" size="5x"/>
          <h3>{t('Partial refund')}</h3>
          <p>{t('A partial refund was completed but some errors occur. Please contact your supervisor with the error messages and then display them to the user.')}</p>
          {this.state.data.errors.map((error) => <p>{error}</p>)}
        </div>
      }
    } else if (this.state.statusCode === 400) {
      return <div className="div-center">
        <br />
        <Icon name="warning" size="5x"/>
        <h3>{t('Error 400')}</h3>
        <div>
          {this.state.data.messages.map((message) => <p>{message}</p>)}
        </div>
      </div>
    } else {
      return <div className="div-center">
        <br />
        <Icon name="warning" size="5x"/>
        <h3>{t('Error')} {this.state.statusCode}</h3>
      </div>
    }
  }

  getBeforeRequestCancellationView() {
    return <div className="div-center">
      <br />
      <Icon name="warning" size="5x"/>
      <h3>{t(`Are you sure you want to ${this.state.action.actionLC} policy number`)} {this.props.policyNumber}?</h3>
    </div>
  }

  showCancellationMessage() {
    let refundSubtotalForSuperVisa = this.getRefundSubtotalForSuperVisa(this.props.data.payments);
    let policyCancellationFee = this.props.policyCancellationFee ? this.props.policyCancellationFee : 0;

    let requiredCancellationFee = this.state.checked ? 0 : Math.min(policyCancellationFee, refundSubtotalForSuperVisa);
    let totalRefund = refundSubtotalForSuperVisa - requiredCancellationFee;

    totalRefund = totalRefund >= 0 ? parseFloat(totalRefund.toFixed(2)) : 0;

    let messageRefundSubtotal = '';
    let messageTotalRefund = '';
    let message1 = '';
    let message2 = ''; 
    let message3 = '';

    switch(this.state.cancellationStatus) {
      case BEFORE_REQUEST_CANCELLATION:
        messageRefundSubtotal = t('Refund Subtotal') + ': $' + refundSubtotalForSuperVisa;
        messageTotalRefund = t('Total Refund') + ': $' + totalRefund;
        message1 = t('Waive Cancellation Fee');
        message2 = t('Required Cancellation Fee') + ': $' + parseFloat(requiredCancellationFee.toFixed(2));
        break;
      case UNDER_CANCELLATION_PREVIEW:
        messageRefundSubtotal = t('Refund Subtotal') + ': $' + refundSubtotalForSuperVisa;
        messageTotalRefund = t('Total Refund') + ': $' + totalRefund;
        message1 = t('Waive Cancellation Fee');
        message2 = t('Required Cancellation Fee') + ': $' + parseFloat(requiredCancellationFee.toFixed(2));
        break;
    }

    if (this.props.setCancellationFee) {

      const authLevel = sessionStorage.getItem('auth_level');
      const allowedAdminLevels = ['admin', 'superadmin', 'masteradmin', 'pmoadmin'];

      return (
        <div>
          { allowedAdminLevels.includes(authLevel) ?
          <div>{((this.state.cancellationStatus == BEFORE_REQUEST_CANCELLATION)  ||  this.state.cancellationStatus == UNDER_CANCELLATION_PREVIEW)
                   ? <input type="checkbox" 
                          value="true" 
                          ref="checkbox" 
                          name="waiveCancellationFee" 
                          disabled={this.state.cancellationStatus == UNDER_CANCELLATION_PREVIEW}
                          onChange={this.waiveCancellationFee.bind(this)} /> : '' } {message1}
          </div>
          : null
          }
          <div>{messageRefundSubtotal}</div>
          <div>{message2}</div>
          <div>{messageTotalRefund}</div>
          <div className='cancellation-error'>{this.state.cancellationError}</div>
        </div>
      )
    } else {
      return (
        <div>
          <div>{message3}</div>
          <div className='cancellation-error'>{this.state.cancellationError}</div>
        </div>
      )
    }
  }

  getRefundSubtotalForSuperVisa(payments) {

    let totalRefund = 0;

    for (let [key, payment] of Object.entries(payments)) {
      if (payment.additional_data.payment_type !== 'Policy Issue Fee' && payment.additional_data.payment_type !== 'Policy Issue Fee Refund' && payment.additional_data.status == 'succeeded') {
        totalRefund = totalRefund + 1.00 * payment.total;
      }
    }
    return parseFloat(totalRefund.toFixed(2));
  }

  waiveCancellationFee() {
    this.setState({checked: !this.state.checked},function(){ this.getCancellationFeesForPayments() });
  }

  render() {
    return <Modal className='cancellation-confirmation-modal' show={this.props.show} onHide={this.close.bind(this)} backdrop={'static'}>
      <Modal.Header>
        <Modal.Title>{t(`${this.state.action.actionUC} Policy`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.props.data ? <Collapse in={this.state.cancellationStatus !== CANCELLATION_CONFIRMED}>
          <div>
            <div>{this.getBeforeRequestCancellationView()}</div>
            <hr />
            <div>
              <h4 className="text-center">
                {this.state.cancellationStatus === UNDER_CANCELLATION_PREVIEW
                  ? t('Refund Configuration Preview')
                  : t('Transaction record')}
              </h4>
              <PaymentHistoryComponent
                cancellationStatus={this.state.cancellationStatus}
                data={this.props.data}
                preview={this.state.cancellationStatus === UNDER_CANCELLATION_PREVIEW}
                onChangeTransactionFee={this.changeTransactionFee.bind(this)}
                onChangeCancellationFee={this.changeCancellationFee.bind(this)}
                refunds={this.state.refunds}
                waiveChecked={this.state.checked}
                cancellationFees={this.state.cancellationFees}
                setCancellationFee={this.props.setCancellationFee}
                applicationData={this.props.applicationData}
              />
            </div>
          </div>
        </Collapse>
          : <div>{t('Payment history is not loaded.')}</div>}
        {this.showCancellationMessage()}
      </Modal.Body>
      <Modal.Footer>
        {
          this.state.data ?
              this.state.cancellationStatus === CANCELLATION_CONFIRMED ?
              <ButtonGroup>
                <button className="btn button-primary" onClick={this.close.bind(this)}>{t('Close')}</button>
              </ButtonGroup>
              :
              <ButtonGroup>
                <button className="btn button-primary" onClick={this.close.bind(this)}>{t('No, Go Back')}</button>
                <button className="btn button-secondary" onClick={this.confirmCancellation.bind(this)}>{t('Confirm Refund')}</button>
              </ButtonGroup>
            :
            <ButtonGroup>
              <button className="btn button-primary" onClick={this.close.bind(this)}>{t('No, Go Back')}</button>
              <button className="btn button-secondary" onClick={this.requestCancellation.bind(this)}>{t('Preview Refund')}</button>
            </ButtonGroup>
        }
      </Modal.Footer>
    </Modal>;
  }
}

CancelPolicyConfirmationComponent.displayName = 'CancelPolicyConfirmationComponent';
export default CancelPolicyConfirmationComponent;



// WEBPACK FOOTER //
// ./src/components/common/CancelPolicyConfirmationComponent.js